module.exports = __webpack_public_path__ + "img/5F4F50_A18E8E_8C7C7B_211A1A-256px.15b448e9.png";